






































































































import { PropType } from 'vue';
import { computed, defineComponent, onMounted, ref, toRefs, watch } from '@vue/composition-api';
import { AdgroupFormData, AudienceTagRelation, CampaignFormData, CatalogListItem, CreateMode } from '@tt4b/ttam-enums';
import { AUDIENCE_TYPE } from './consts';
import Audience from './index';
import TtamAudience from './audience-base-compose.vue';
import TtamAudienceSalesRetarget from './audience-sales-retarget-compose.vue';
import TtamExpandButton from '@/components/common/expand-button/index.vue';
import { useAdgroupIos14, useAllowlist, useInjectAbTest } from '@tt4b/ttam-hooks';

const name = 'ttam-audience-sales-compose';
export default defineComponent({
  name,
  components: {
    TtamAudienceType: Audience.TtamAudienceType,
    TtamAudienceTypeAlert: Audience.TtamAudienceTypeAlert,
    TtamAudienceTypeAlertNew: Audience.TtamAudienceTypeAlertNew,
    TtamAudienceInfo: Audience.TtamAudienceInfo,
    TtamAntiDiscriminationCheckbox: Audience.TtamAntiDiscriminationCheckbox,
    TtamExpandButton,
    TtamAudience,
    TtamAudienceSalesRetarget,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
    catalogInfo: {
      type: Object as PropType<CatalogListItem>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, catalogInfo, createMode } = toRefs(props);
    const audienceType = computed({
      get: () => adgroupData.value.dpaLocalAudience,
      set: val => {
        emit('dpa-local-audience-change', val);
      },
    });
    const antiDiscrimination = computed({
      get: () => Boolean(adgroupData.value.antiDiscrimination),
      set: val => {
        emit('anti-discrimination-change', val);
      },
    });
    const { isNewEventSourceUI } = useInjectAbTest();
    const { isProductSaleRetargeting } = Audience.useRetargetingIs({ adgroupData, campaignData });
    const isRetargeting = computed(() => audienceType.value === AUDIENCE_TYPE.RETARGET.value);
    const expandSettingsVisible = ref(false);
    const audienceVisible = computed(
      () => expandSettingsVisible.value || audienceType.value === AUDIENCE_TYPE.NORMAL.value,
    );
    const { eventSourceAlertVisible } = Audience.usePropsEventSourceAlertVisible({ catalogInfo, isRetargeting });
    const isNewEventSourceAlertVisible = computed(() => eventSourceAlertVisible.value && isNewEventSourceUI.value);
    const { eventsSourceCheckAlertVisible } = Audience.usePropsEventsSourceCheckAlertVisible({ catalogInfo });
    const { audienceTypeValidator } = Audience.useAudienceTypeRules({ eventSourceAlertVisible });
    const { antiDiscriminationVisible, targetAudienceDataHasDeleted } = Audience.usePropsAntiDiscriminationVisible({
      adgroupData,
    });
    const { antiDiscriminationValidator } = Audience.useAntiDiscriminationRule();

    const { isVSARetargetAudienceUnionWhite } = useAllowlist();
    const enableTagRelation = computed(() => isRetargeting.value && isVSARetargetAudienceUnionWhite.value);

    const onTagRelationChange = val => {
      emit('tag-relation-change', val);
    };

    const onIncludeChange = val => {
      emit('include-change', val);
    };
    const onExcludeChange = val => {
      emit('exclude-change', val);
    };
    const onDpaRetargetingTypeChange = val => {
      emit('dpa-retargeting-type-change', val);
    };
    const onIncludeCustomActionsChange = val => {
      emit('include-custom-actions-change', val);
    };
    const onExcludeCustomActionsChange = val => {
      emit('exclude-custom-actions-change', val);
    };

    const resetTagRelation = () => {
      if (
        isVSARetargetAudienceUnionWhite.value &&
        adgroupData.value.customAudienceTagRelation !== AudienceTagRelation.UNSET
      ) {
        emit('tag-relation-change', AudienceTagRelation.UNSET);
      }
    };

    const initTagRelation = () => {
      if (enableTagRelation.value && adgroupData.value.customAudienceTagRelation === AudienceTagRelation.UNSET) {
        // 表示之前没有设置过 customAudienceTagRelation，历史数据全部是narrow
        if (createMode.value === CreateMode.EDIT && adgroupData.value.retargetingTags?.length > 0) {
          emit('tag-relation-change', AudienceTagRelation.INTERSECTION);
        } else {
          emit('tag-relation-change', AudienceTagRelation.UNION);
        }
      }
    };

    onMounted(() => {
      const { isDedicateCampaign } = useAdgroupIos14({
        adgroupFormData: adgroupData,
        campaignFormData: campaignData,
      });
      if (isDedicateCampaign.value) {
        emit('dpa-retargeting-type-change', 0);
      }

      initTagRelation();
    });

    watch(
      () => isRetargeting.value,
      newVal => {
        if (!newVal) {
          resetTagRelation();
        } else {
          initTagRelation();
        }
      },
    );

    watch(
      () => targetAudienceDataHasDeleted.value,
      val => {
        if (val) {
          emit('anti-discrimination-change', false);
        }
      },
      {
        immediate: true,
      },
    );
    return {
      name,
      isRetargeting,
      audienceType,
      audienceVisible,
      expandSettingsVisible,
      isProductSaleRetargeting,
      eventSourceAlertVisible,
      isNewEventSourceUI,
      isNewEventSourceAlertVisible,
      eventsSourceCheckAlertVisible,
      enableTagRelation,
      audienceTypeValidator,
      antiDiscrimination,
      antiDiscriminationVisible,
      antiDiscriminationValidator,
      onTagRelationChange,
      onIncludeChange,
      onExcludeChange,
      onDpaRetargetingTypeChange,
      onIncludeCustomActionsChange,
      onExcludeCustomActionsChange,
    };
  },
});
